<template>
  <v-card
    :wxid="$options.name"
    :class="[{ disabled: isTileDisabled, unfocused: isTileUnfocused }, targetStatusClass]"
    class="tile status-pictogram"
    tag="section"
    sf="3"
  >
    <grouped-tile-selector-menu :tile-index="tileIndex" />
    <div class="tile-inner">
      <h3 :title="$t('tiles.ooe')" class="primary-title">
        {{ $t("tiles.ooe") }}
        <v-icon v-if="!isTileAuthorized()">mdi-lock</v-icon>
      </h3>
      <h2 class="primary-value">{{ primaryValue }}</h2>

      <product-rate-calibration v-if="isCurrentProductInCalibration" />

      <section class="status-details">
        <dl>
          <dt>{{ targetType }}</dt>
          <dd class="d-flex align-center">
            <v-icon class="mr-1">mdi-target</v-icon>
            {{ targetValue }}
          </dd>
        </dl>
        <div class="pictogram" />
      </section>
    </div>
  </v-card>
</template>

<script>
import { mapGetters } from "vuex";
import GroupedTileSelectorMenu from "@/components/dashboard/tiles/GroupedTileSelectorMenu";
import TileBase from "@/components/dashboard/tiles/TileBase";
import Tiles from "@/components/Tiles";
import Helpers, { dash } from "@/helpers";
import ProductRateCalibration from "@/components/ui/ProductRateCalibration.vue";

export default {
  name: "TileOoe",
  extends: TileBase,
  inheritAttrs: false,
  components: { ProductRateCalibration, GroupedTileSelectorMenu },
  computed: {
    ...mapGetters("dashboard", [
      "ooe",
      "ooeTarget",
      "currentProductSku",
      "currentProductName",
      "isCurrentProductInCalibration",
    ]),
    ...mapGetters("packages", ["activePuHasRequiredFeature"]),
    ...mapGetters("tiles", ["selectedTileIndex"]),
    isTileUnfocused() {
      return this.selectedTileIndex !== null && this.tileIndex !== this.selectedTileIndex;
    },
    isTileDisabled() {
      return !this.isTileAuthorized();
    },
    primaryValue() {
      if (this.ooe) {
        return this.isTileAuthorized() && !this.isCurrentProductInCalibration ? Helpers.round(this.ooe, 1) + "%" : dash;
      }
      return dash;
    },
    targetValue() {
      if (this.ooeTarget) {
        return Helpers.round(this.ooeTarget, 1) + "%";
      } else {
        return this.$t("common.nA");
      }
    },
    targetType() {
      return this.$t("dashboard.targetInfo.line");
    },
    targetStatusClass() {
      let statusClass = this.defaultStateCssClass;
      if (this.isCurrentProductInCalibration) return statusClass;
      if (this.ooeTarget && this.ooe) {
        const value = this.ooe - this.ooeTarget;
        if (value >= 0) {
          statusClass = this.successCssClass;
        } else if (value >= -5) {
          statusClass = this.warningCssClass;
        } else {
          statusClass = this.errorCssClass;
        }
      }
      return statusClass;
    },
  },
  methods: {
    isTileAuthorized() {
      return this.activePuHasRequiredFeature(Tiles.ooe.requiredFeature);
    },
  },
};
</script>
